import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  useTheme,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const btnStyles = {
  borderRadius: "8px",
  padding: "8px 16px",
  color: "#fff",
  fontWeight: 500,
  fontSize: 15,
  boxShadow: "none !important",
  textWrap: "nowrap",
  textTransform: "none",
  border: "none",
};

const ConfirmationModal = ({
  title,
  text,
  okText,
  cancelText,
  handleOpen,
  open,
  handleClose,
  actionType,
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "0px 4px 18px 0px rgba(47, 43, 61, 0.16)",
          maxWidth: "550px",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <IconButton
        sx={{
          height: "30px",
          width: "30px",
          position: "absolute",
          right: 10,
          top: 10,
          backgroundColor: "#fff",
          color: "#3E3F4C",
          zIndex: 2,
        }}
        onClick={handleClose}
      >
        <CloseOutlinedIcon sx={{ fontSize: "17px" }} />
      </IconButton>

      <DialogTitle
        sx={{
          padding: "24px",
          fontSize: "18px",
          fontWeight: 600,
          lineHeight: "20px",
          color: "rgba(47, 43, 61, 0.9)",
          borderBottom: "1px solid #EAEAEA",
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent
        sx={{
          padding: "24px !important",
          fontSize: "18px",
          fontWeight: 400,
          lineHeight: "28px",
          color: "rgba(47, 43, 61, 0.9)",
        }}
      >
        <Typography sx={{ fontSize: "18px", color: "rgba(47, 43, 61, 0.9)" }}>
          {text}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ padding: "12px 24px" }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="stretch"
          gap="12px"
          width="100%"
          sx={{
            [theme.breakpoints.up("450")]: {
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            },
          }}
        >
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{
              ...btnStyles,
              backgroundColor: "rgba(128, 131, 144, 1)",
              width: "100%",
              order: 2,
              [theme.breakpoints.up("450")]: {
                width: "auto",
                order: 1,
              },
            }}
          >
            {cancelText}
          </Button>
          <Button
            variant="outlined"
            onClick={handleOpen}
            sx={{
              ...btnStyles,
              backgroundColor:
                actionType === "reject" || actionType === "remove"
                  ? "rgba(183, 72, 74, 1)"
                  : "rgba(37, 124, 109, 1)",
              width: "100%",
              order: 1,
              [theme.breakpoints.up("450")]: {
                width: "auto",
                order: 2,
              },
            }}
          >
            {okText}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
